export default "__VITE_ASSET__BcPiNT_O__"